import { HomePage } from '@/pages/HomePage';
import { InvitationPage } from '@/pages/InvitationPage';
import * as Sentry from '@sentry/react';
import type { QueryClient } from '@tanstack/react-query';
import {
  Outlet,
  createRootRouteWithContext,
  createRoute,
  redirect,
} from '@tanstack/react-router';
import { routes } from './routes';

export interface MyRouterContext {
  queryClient: QueryClient;
}

export const rootRoute = createRootRouteWithContext<MyRouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold text-gray-800">
          404 - Not Found
        </h1>
        <p className="text-gray-600">
          The page or resource you're looking for doesn't exist.
        </p>
      </div>
    </div>
  ),
  errorComponent: ({ error }) => {
    Sentry.captureException(error);
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold text-red-600">
            Something went wrong
          </h1>
          <p className="text-gray-600">
            {error.message || 'An unexpected error occurred'}
          </p>
          {import.meta.env.DEV && error.stack && (
            <pre className="mt-4 max-w-2xl overflow-auto rounded bg-gray-100 p-4 text-left text-sm">
              {error.stack}
            </pre>
          )}
        </div>
      </div>
    );
  },
});

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routes.home,
  component: HomePage,
});

export const invitationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routes.invitation,
  component: InvitationPage,
});

export const legacySubscriptionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subscriptions/$id',
  beforeLoad: () => {
    throw redirect({
      to: routes.auth.login,
    });
  },
});
